import * as types from '../actions/action-types';
import moment from 'moment';

const INITIAL_STATE = {
    eventstoday: 0,
    costsResults: {
        costs: {
            costUnder5k: 0,
            cost5k10k: 0,
            costOver10k: 0
        }
    },
    eventStatusBreakDown: {
        isLoading: false,
        eventCreations: 0,
        eventReview: 0,
        afterActionIncomplete: 0,
        afterActionReview: 0,
        eventAAClosed: 0
    },
    tasksDueTotal: 0,
    tasksDueLoading: false
};

export const getDashboardETResultsNumber = state => state.eventstoday || 0;
export const getDashboardCostsNumber = state => state.costsResults.costs || 0;
export const getEventStatusBreakDown = state => state.eventStatusBreakDown;
export const getTasksDueTotal = state => state.tasksDueTotal;
export const getTasksDueLoading = state => state.tasksDueLoading;

const checkBetween = data => {
    let isBetweenCount = 0;
    for (let i = 0; i < data.length; i++) {
        if (
            moment().isBetween(data[i].startDate, data[i].endDate, 'days', '[]')
        ) {
            if (!!data[i].endDate) {
                isBetweenCount++;
            }
        }
    }
    return isBetweenCount;
};

const setCost = (data, filter1, filter2) => {
    let filterLength = 0;
    data.filter(row => {
        if (filter2) {
            if (row.cost >= filter1 && row.cost < filter2) {
                filterLength++;
            }
        } else {
            if (row.cost >= filter1) {
                filterLength++;
            }
        }
        return row;
    });
    return filterLength;
};

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.FETCH_DASHBOARD_RESULTS_SUCCESS) {
        return {
            ...state,
            eventstoday:
                action.filtertype === 'eventstoday'
                    ? checkBetween(action.payload.data)
                    : state.eventstoday
        };
    } else if (action.type === types.FETCH_DASHBOARD_COSTS_SUCCESS) {
        return {
            ...state,
            costsResults: {
                costs: {
                    costUnder5k: setCost(action.payload.data, 0, 5000),
                    cost5k10k: setCost(action.payload.data, 5000, 10000),
                    costOver10k: setCost(action.payload.data, 10000)
                }
            }
        };
    } else if (action.type === types.EVENT_STATUS_BREAKDOWN_LOADING) {
        return {
            ...state,
            eventStatusBreakDown: {
                ...state.eventStatusBreakDown,
                ...action.eventStatusBreakDown,
                isLoading: !state.eventStatusBreakDown.isLoading
            }
        };
    } else if (action.type === types.EVENT_STATUS_BREAKDOWN_DATA) {
        return {
            ...state,
            eventStatusBreakDown: {
                ...state.eventStatusBreakDown,
                ...action.eventStatusBreakDown
            }
        };
    } else if (action.type === types.TASKS_DUE_TOTAL) {
        return {
            ...state,
            tasksDueTotal: action.total
        };
    } else if (action.type === types.TASKS_DUE_LOADING) {
        return {
            ...state,
            tasksDueLoading: !state.tasksDueLoading
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js